import { render, staticRenderFns } from "./PostPosition.vue?vue&type=template&id=3446cda8&scoped=true"
import script from "./PostPosition.vue?vue&type=script&lang=js"
export * from "./PostPosition.vue?vue&type=script&lang=js"
import style0 from "./PostPosition.vue?vue&type=style&index=0&id=3446cda8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3446cda8",
  null
  
)

export default component.exports